module.exports = __webpack_public_path__ + "static/media/usuario.13ffaa1f.png";